import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "panel"]
  static values = { open: Boolean }

  connect() {
    this.toggle(this.openValue)
  }

  show(event) {
    event.preventDefault()
    this.toggle(true)
    this.panelTarget.querySelector("textarea")?.focus()
  }

  hide(event) {
    event.preventDefault()
    this.toggle(false)
    this.triggerTarget.focus()
  }

  toggle(open) {
    this.panelTarget.hidden = !open
    this.triggerTarget.setAttribute("aria-expanded", String(open))
  }
}
